Vue.component('navigation', {
  template: templates.navigation2,
  data() {
    return {
      model: {
        page: 'cards',
        cards: 'yours'
      }
    }
  },
  methods: {
    click(page) {
      const c = this;
      c.model.page = page;
      c.$root.$emit('showPage', page);
    },
    cards(page) {
      const c = this;
      c.model.cards = page;
      c.$root.$emit('showCards', page);
      
      $('.playing-card:not(.disabled)').addClass('flipped');
    }
  }
});

const vueApp = new Vue({
  el: '[data-view="viewer-dashboard"]',
  data() {
    return {
      model: {
        page: 'cards',
        cards: 'yours'
      }
    }
  },
  mounted() {
    const c = this;
    c.$root.$on('showPage', page => {
      c.model.page = page;
    });

    c.$root.$on('showCards', page => {
      c.model.cards = page;
    });
  }
});